import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import config from "../config";
import { message } from 'antd';

class SOSLogReportStore {
  soslogRport = []
  total = 0
  loading = false
  pythonReportMessage = false
  pythonReportErrorMessage = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      soslogRport: observable,
      total: observable,
      loading: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable,
      loadData: action,

    });
    this.rootStore = rootStore;

  }

  async loadData({ offset, limit, companyId, fromDate, toDate, pageNo }) {
    this.loading = true;
    var response
    var postData = { "companyId": companyId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }

    if (config.pythonReport == 1) {
      response = await postApi.getClient('report').post("/alert_report/sosLogReport", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=traxi_booking&a=sosLogReport", "postData=" + base64Input);
    }


    this.soslogRport = response?.data?.data?.soslogreport

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {
    if (config.pythonReport == 1) {
      try {

        await postApi.getClient("report").post("/alert_report/sosLogReport/download/excel", getData, {
          responseType: "blob",
        });

        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=traxi_booking&a=exportSosLogexcel&cid=" +
        getData.companyId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport == 1) {

      try {
        console.log("exportpdf")
        await postApi.getClient("report").post("/alert_report/sosLogReport/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=traxi_booking&a=exportSosLogPdf&cid=" +
        getData.companyId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }



}

export default SOSLogReportStore;
